export type ObservationPhoto = { id: number; imageUrl: string; active?: boolean };
export type ObservationDraft = { visible: string; question: string };

const EMPTY_DRAFT: ObservationDraft = { visible: '', question: '' };
const DRAFT_PREFIX = 'truthpick_photo_observation_';

export function availableObservationPhotos<T extends ObservationPhoto>(photos: T[]): T[] {
    return photos.filter((photo) => photo.active !== false && Number.isFinite(photo.id) && /^https?:\/\/|^\/uploads\//.test(photo.imageUrl))
        .sort((a, b) => b.id - a.id);
}

export function weeklyObservationPhoto<T extends ObservationPhoto>(photos: T[], now: Date): T | undefined {
    const available = availableObservationPhotos(photos);
    if (available.length === 0) return undefined;
    const dayMs = 24 * 60 * 60 * 1000;
    const week = Math.floor((now.getTime() + 9 * 60 * 60 * 1000 - 2 * dayMs) / (7 * dayMs));
    return available[((week % available.length) + available.length) % available.length];
}

export function readObservationDraft(photoId: number): ObservationDraft {
    try {
        const value = JSON.parse(localStorage.getItem(`${DRAFT_PREFIX}${photoId}`) || 'null');
        return {
            visible: typeof value?.visible === 'string' ? value.visible : '',
            question: typeof value?.question === 'string' ? value.question : ''
        };
    } catch { return { ...EMPTY_DRAFT }; }
}

export function saveObservationDraft(photoId: number, draft: ObservationDraft): void {
    localStorage.setItem(`${DRAFT_PREFIX}${photoId}`, JSON.stringify(draft));
}

export function clearObservationDraft(photoId: number): void {
    localStorage.removeItem(`${DRAFT_PREFIX}${photoId}`);
}

export function observationComment(draft: ObservationDraft): string {
    return [draft.visible.trim() && `사진에서 본 것: ${draft.visible.trim()}`, draft.question.trim() && `궁금한 점: ${draft.question.trim()}`]
        .filter(Boolean).join('\n');
}
